import React from "react";
import useForm from "./index";
import Label from "./label";
import { TForm, TInputElementProps, TInputProps } from "./types";

export const NumberInput = ({ container, label, input, tooltip, className, hidden, options }: TInputElementProps<TNumberInput>) => {
    if (hidden) {
        return null;
    }

    return (
        <div {...container} className={container?.className ?? className}>
            <Label {...label} tooltip={tooltip} options={options}/>
            <input {...input}/>
        </div>
    );
}

type TNumberInput = string;
const useNumberInput = <T extends TNumberInput>(props: TInputProps<T>): TForm<TNumberInput> => {
    const form = useForm<TNumberInput>({
        id: "number",
        default: "",
        ...props,
    })

    return {
        ...form,
    }
}

export default useNumberInput;
